import { combineReducers } from 'redux';
import feeSettings from './feeSettings/reducer';
import pubnub from './pubnub/reducer';

export default combineReducers({
  feeSettings,
  pubnub,
});
